import type { LevelPhase } from './useLevelRunner';

/**
 * Whether the level play surface (incl. R3F Canvas for Søppelbilen) should stay
 * mounted for this phase.
 *
 * Custom-play worlds must remain mounted through `reward`. Unmounting the Canvas
 * while `@react-three/fiber`'s async `configure`/`onCreated` is in flight calls
 * `events.connect(null)` → `target.addEventListener` crash.
 */
export function shouldMountLevelWorld(
  phase: LevelPhase,
  hasCustomPlay: boolean
): boolean {
  if (hasCustomPlay) {
    return (
      phase === 'start' ||
      phase === 'play' ||
      phase === 'finish' ||
      phase === 'celebration' ||
      phase === 'reward'
    );
  }
  // Demo / non-custom: classic start card owns `start`; world only for play+celebration.
  return phase === 'play' || phase === 'celebration';
}
